/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import withRouter from '../Components/Common/withRouter';

// import Components
import Header from './Header';
import Sidebar from './Sidebar';

// import actions
import {
    changeLayout,
    changeSidebarTheme,
    changeLayoutMode,
    changeLayoutWidth,
    changeLayoutPosition,
    changeTopbarTheme,
    changeLeftsidebarSizeType,
    changeLeftsidebarViewType,
    changeSidebarImageType,
    changeSidebarVisibility
} from '../slices/thunks';

// redux
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { AuthUser } from 'Components/Common/Util';
import { useLocation } from 'react-router-dom';
import { store } from 'slices/persister';

const Layout = (props: any) => {
    const [headerClass, setHeaderClass] = useState('');
    const dispatch: any = useDispatch();
    const userDetails: any = AuthUser();
    const location = useLocation();
    const urlPath = location.state;

    let userName = userDetails?.userProfile?.roles?.[0]?.role;
    if (userDetails?.userProfile?.roles?.length > 1) {
        userName = store.getState()?.SelectedRole?.role?.value;
    }

    const selectLayoutState = (state: any) => state.Layout;
    const selectLayoutProperties = createSelector(selectLayoutState, (layout) => ({
        layoutType: layout.layoutType,
        leftSidebarType: layout.leftSidebarType,
        layoutModeType: layout.layoutModeType,
        layoutWidthType: layout.layoutWidthType,
        layoutPositionType: layout.layoutPositionType,
        topbarThemeType: layout.topbarThemeType,
        leftsidbarSizeType: layout.leftsidbarSizeType,
        leftSidebarViewType: layout.leftSidebarViewType,
        leftSidebarImageType: layout.leftSidebarImageType,
        preloader: layout.preloader,
        sidebarVisibilitytype: layout.sidebarVisibilitytype
    }));
    // Inside your component
    const {
        layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        sidebarVisibilitytype
    } = useSelector(selectLayoutProperties);

    /*
     *layout settings
     */
    useEffect(() => {
        if (
            layoutType ||
            leftSidebarType ||
            layoutModeType ||
            layoutWidthType ||
            layoutPositionType ||
            topbarThemeType ||
            leftsidbarSizeType ||
            leftSidebarViewType ||
            leftSidebarImageType ||
            sidebarVisibilitytype
        ) {
            window.dispatchEvent(new Event('resize'));
            dispatch(changeLeftsidebarViewType(leftSidebarViewType));
            dispatch(changeLeftsidebarSizeType(leftsidbarSizeType));
            dispatch(changeSidebarTheme(leftSidebarType));
            dispatch(changeLayoutMode(layoutModeType));
            dispatch(changeLayoutWidth(layoutWidthType));
            dispatch(changeLayoutPosition(layoutPositionType));
            dispatch(changeTopbarTheme(topbarThemeType));
            dispatch(changeLayout(layoutType));
            dispatch(changeSidebarImageType(leftSidebarImageType));
            dispatch(changeSidebarVisibility(sidebarVisibilitytype));
        }
    }, [
        layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        sidebarVisibilitytype,
        dispatch
    ]);
    /*
     *call dark/light mode
     */
    const onChangeLayoutMode = (value: any) => {
        if (changeLayoutMode) {
            dispatch(changeLayoutMode(value));
        }
    };

    // class add remove in header
    useEffect(() => {
        window.addEventListener('scroll', scrollNavigation, true);
    });

    function scrollNavigation() {
        const scrollup = document.documentElement.scrollTop;
        if (scrollup > 50) {
            setHeaderClass('topbar-shadow');
        } else {
            setHeaderClass('');
        }
    }

    useEffect(() => {
        const humberIcon = document.querySelector('.hamburger-icon') as HTMLElement;
        if (sidebarVisibilitytype === 'show' || layoutType === 'vertical' || layoutType === 'twocolumn') {
            humberIcon?.classList.remove('open');
        } else {
            humberIcon && humberIcon?.classList.add('open');
        }
    }, [sidebarVisibilitytype, layoutType]);

    return (
        <React.Fragment>
            <div id="layout-wrapper">
                {/* hide header when role is User */}
                {!(location?.state?.header === 'hide') && (
                    <Header headerClass={headerClass} layoutModeType={layoutModeType} onChangeLayoutMode={onChangeLayoutMode} />
                )}
                {/* when role is user dont't display sideBar */}
                {userName !== 'USER' && <Sidebar layoutType={layoutType} />}
                {/* when role is user then display main-content empty  */}
                <div className={`${userName !== 'USER' ? 'main-content' : ''}`}>{props.children}</div>
            </div>

            {/* <div id="layout-wrapper">
                {!(location?.state?.header === 'hide') && (
                    <Header headerClass={headerClass} layoutModeType={layoutModeType} onChangeLayoutMode={onChangeLayoutMode} />
                )}
                 <Sidebar layoutType={layoutType} />
                <div className='main-content'>{props.children}</div>
            </div> */}
        </React.Fragment>
    );
};

Layout.propTypes = {
    children: PropTypes.object
};

export default withRouter(Layout);
